var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 28L36 22H22C20.8954 22 20 21.1046 20 20V8C20 6.89543 20.8954 6 22 6H40C41.1046 6 42 6.89543 42 8V28Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 28L36 22H22C20.8954 22 20 21.1046 20 20V8C20 6.89543 20.8954 6 22 6H40C41.1046 6 42 6.89543 42 8V28",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M28 30V34C28 35.1046 27.1046 36 26 36H12L6 42V22C6 20.8954 6.89543 20 8 20H12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.9a93845b2b3e1621688c83be43beb3bc.svg";
export { ForwardRef as ReactComponent };